import { useCallback, useEffect } from 'react';
import { isEscapePressed } from 'utils';

export default function useCloseOnEscape(onClose: () => void) {
  const onEscape = useCallback(
    (e: KeyboardEvent) => {
      if (isEscapePressed(e)) {
        // don't remove settimeout
        setTimeout(() => {
          onClose();
        }, 0);
      }
    },
    [onClose],
  );

  useEffect(() => {
    document.addEventListener('keydown', onEscape);

    return () => {
      document.removeEventListener('keydown', onEscape);
    };
  }, [onEscape]);
}
